export default __webpack_public_path__ + "static/media/Active_Customer.867c8fe2.svg";